import React, { Component } from 'react';
import { Field } from 'redux-form';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchDropdown } from '../../../actions/actionCreators';

import { renderSearchMultipleDropdown, renderSearchDropDown } from '../../common/form/FieldHelper';

class RolesDropdown extends Component {

  render() {

    const {
      form,
      multiple,
      name,
      onPostChange,
      searchFn,
      isPrefiltered,
      preload = true,
      excluded_roles = [],
      included_roles =[] ,
    } = this.props;

    const searchParams = {};
    if (excluded_roles.length) {
      searchParams.excluded_roles = excluded_roles;
    }
    if (isPrefiltered) {
      searchParams.included_roles = included_roles;
      searchParams.minimum_should_match = 1;
    };

    return (
      <div className="field">
        <Field
          {...this.props}
          searchParams={searchParams}
          name={name}
          formId={form}
          searchFn={searchFn}
          dropdownType='role'
          type='role'
          valueField='id'
          component={ multiple ? renderSearchMultipleDropdown : renderSearchDropDown }
          onPostChange={onPostChange}
          preload={preload}
        />
      </div>
    );
  }
}


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    searchFn: fetchDropdown
  }, dispatch);
}

export default connect(null, mapDispatchToProps)(RolesDropdown);
